import React, { useState } from "react";
import PropTypes from "prop-types";
import analytics from "web/script/analytics/analytics";
import browser from "web/script/utils/browser";
import Carousel from "web/react/components/product-gallery/product-gallery-carousel/product-gallery-carousel";
import FullscreenGallery from "web/react/components/product-gallery/product-gallery-fullscreen/product-gallery-fullscreen";

function ProductGallery({
    dotsInsideGallery,
    images,
    relatedProducts,
    currentLinkId,
    swipeRedirect,
}) {
    const viewport = browser.getViewport() === browser.VIEWPORTS.DESKTOP ? "desktop" : "mobile";
    const analyticsAction = `${viewport}_gallery`;
    const [firstInteraction, setFirstInteraction] = useState(false);
    const [fullscreen, setFullscreen] = useState(false);
    const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

    const settings = {
        speed: 200,
        cssEase: "ease-out",
        slidesToShow: 1.3,
        infinite: true,
        arrows: false,
        dots: true,
        lazyLoad: false,
        centerMode: false,
        touchThreshold: 20,
        swipeToSlide: false,
        variableWidth: true,
    };

    const galleryProps = {
        analyticsAction: analyticsAction,
        dotsInsideGallery: dotsInsideGallery,
        firstInteraction: firstInteraction,
        handleFirstInteraction: handleFirstInteraction,
        images: images,
        relatedProducts: relatedProducts,
        handleImageClick: (index) => handleOpenFullscreen(index),
        settings: settings,
        currentLinkId: currentLinkId,
        swipeRedirect: swipeRedirect,
    };

    function handleFirstInteraction() {
        setFirstInteraction(true);
        analytics.event("engagement", analyticsAction, "interacted");
    }

    function handleOpenFullscreen(index) {
        if (!firstInteraction) {
            handleFirstInteraction();
        }
        setCurrentSlideIndex(index);
        setFullscreen(true);
    }

    return (
        <div>
            <Carousel {...galleryProps} />
            <FullscreenGallery
                analyticsAction={analyticsAction}
                isOpen={fullscreen}
                onClose={() => setFullscreen(false)}
                currentSlideIndex={currentSlideIndex}
                images={images}
                relatedProducts={relatedProducts}
                firstInteraction={firstInteraction}
                currentLinkId={currentLinkId}
            />
        </div>
    );
}

export default ProductGallery;

ProductGallery.displayName = "ProductGallery";

ProductGallery.propTypes = {
    dotsInsideGallery: PropTypes.bool,
    images: PropTypes.array.isRequired,
    relatedProducts: PropTypes.array,
    currentLinkId: PropTypes.string,
    swipeRedirect: PropTypes.bool,
};
